import React, {useEffect, useState} from 'react';
import 'datatables.net';
import 'datatables.net-responsive';
import {GET_COLLECTION_AGGREGATE_DATA} from '../../api';
import $ from "jquery";
import {capitalize} from "../../utils/capitalize";
import cogoToast from "cogo-toast";
import moment from "moment/moment";
import {user, getUserReport} from "../../api/app";
import formatNumber from "../../utils/formatNumber";
import {useSelector} from "react-redux";
import DTLeaderBoard from "../../components/layout/DTLeaderBoard";

let searchableFields = [
    { field: 'name', isNumeric: false },
    { field: 'mobile_number', isNumeric: true }
]

const Dashboard = () => {

    document.title = "Dashboard";

    const token = localStorage.getItem('jwtToken');
    const auth = useSelector((state) => state.auth.user);
    const [id, setId] = useState(new Date().getTime());

    const [stateReady, setStateReady] = useState(false);

    useEffect(() => {
        getUserReport().then((response) => {
            if(!response.error) {
                $('#total-users').text(formatNumber(response.payload.total_users, "digit"));
                $('#total-assignment').text(formatNumber(response.payload.total_assignments, "digit"));
                $('#total-submission').text(formatNumber(response.payload.total_submissions, "digit"));
            }
        });
    }, []);

    useEffect(() => {
        let table = $('#message_table').DataTable({
            responsive: true,
            language: {
                searchPlaceholder: 'Search name',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Assignment Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function (data, callback) {
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "user",
                        searchableFields,
                        filter: {
                            admin: auth.user.role === 'admin' ? {} : `ObjectId(${auth.user.sub})`
                        },
                        pageSize: data.start,
                        format: 'json',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];
                        res.data.map((data) => {
                            array.push({raw: data})
                        });
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function (data) {
                        return capitalize(data.name);
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data.mobile_number
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return moment(data.date.iso).format("Do MMM, YYYY")
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return `<nav class="nav nav-icon-only"><a href="#/user/${data._id}" class="nav-link"><i class="fa fa-eye"></i> View</a> <a href="#" class="nav-link delete_user"><i class="fa fa-trash"></i> Delete</a></nav>`
                    },
                    "targets": 3
                }
            ]
        });

        table.on('click', '.delete_user', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            $(".data-message").text(`Are you sure, you want to delete this user, ${extract_td.raw.name}?`);
            $('#delete-data').unbind("click").click(function(){

                $("#modalConfirm").modal("hide");
                $(".modal-backdrop").remove();

                const options = {
                    position: "top-right",
                    hideAfter: 0
                };

                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                let data = {
                    id: extract_td.raw._id,
                }

                user("delete", data).then((result) => {
                    hide();
                    if(!result.error) {
                        reloadTable();
                        cogoToast.success("User successfully removed.", {position: "top-right"});
                    }
                });
            });

            $("#modalConfirm").modal({ backdrop: 'static', focus: false, show: true });
        });

        return () => {
            table.destroy();
        }

    }, []);

    const handleShowModal = () => {
        $('#message_bulk_form').parsley();
        $("#modalBulkMessage").modal("show");
    }

    const handleLeaderboard = () => {
        setId(new Date().getTime());
        $("#modalLeaderboard").modal("show");
    }

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    }

    const handleBulkSMSSubmit = (e) => {
        e.preventDefault();
        let name = $('#name').val();
        let mobile_number = $('#mobile').val();
        let password = $('#password').val();

        setStateReady(true);

        let data = {
            name,
            mobile_number,
            password
        };

        user("post", data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success("User successfully created.", {position: "top-right", hideAfter: 5});
                resetForm("modalBulkMessage", "message_bulk_form");
                reloadTable();
            }
        });
    }

    const reloadTable = () => {
        $('#message_table').DataTable().ajax.reload(null, false);
    };

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item active" aria-current="page">Dashboard</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Dashboard</h4>
                    </div>
                    <div className="d-none d-md-block">
                        {auth.user.role !== 'admin' ? <button className="btn btn-sm pd-x-15 btn-secondary btn-uppercase mg-l-5 outline-none" onClick={handleLeaderboard.bind()}><i className="wd-10 mg-r-5 fa fa-signal"></i> Leaderboard</button> : null}
                        <button className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5 outline-none" onClick={handleShowModal.bind()}><i className="wd-10 mg-r-5 fa fa-plus"></i> Add User</button>
                    </div>
                </div>

                <div className="row row-sm">
                    <div className="col-sm-6 col-lg-6">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Total Users</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-users" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span id="total-gender" className="tx-11 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-6 mg-t-10 mg-lg-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Total Assignment</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-assignment" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span id="date-current" className="tx-11 tx-color-02 mg-b-0 mg-t-5">-</span>
                        </div>
                    </div>

                    <div className="col-md-12 mt-3">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Users</h6>
                                <div className="d-flex tx-18">
                                    <a href="javascript:void(0)" className="link-03 lh-0 mg-l-10" onClick={() => reloadTable()}><i className="icon ion-md-refresh"></i></a>
                                </div>
                            </div>
                            <div className="card-body table-responsive">
                                <table id="message_table" className="table" style={{width: "100%"}}>
                                    <thead>
                                    <tr>
                                        <th className="wd-25p">Name</th>
                                        <th className="wd-25p">Mobile Number</th>
                                        <th className="wd-25p">Date</th>
                                        <th className="wd-25p">Actions</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalLeaderboard" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                        <div className="modal-content tx-14">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel6">Leaderboard</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => $("#tx-support-level").text("Select Date")}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <DTLeaderBoard id={id}/>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                        <div className="modal-content tx-14">
                            <div className="modal-header">
                                <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="mg-b-0 data-message">Empty</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" id="delete-data" className="btn btn-success btn-block">Yes, Delete</button>
                                <button type="button" className="btn btn-danger btn-block mt-0" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalBulkMessage" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </a>
                                <div className="media-body"><a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={resetForm.bind(null, "modalBulkMessage", "message_bulk_form")} aria-label="Close"><span aria-hidden="true">×</span></a><h4 className="tx-18 tx-sm-20 mg-b-2">Add User</h4><p className="tx-13 tx-color-02 mg-b-0">Add user to the system.</p></div>
                            </div>
                            <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                <form id="message_bulk_form" className="parsley-style-1" onSubmit={handleBulkSMSSubmit.bind()}>
                                    <div id="senderWrapper" className="form-group parsley-input">
                                        <label>Full Name<span className="tx-danger">*</span></label>
                                        <input id="name" type="text" className="form-control"
                                               placeholder="Enter full name"
                                               autoComplete="off"
                                               data-parsley-class-handler="#senderWrapper" required/>
                                    </div>

                                    <div id="subjectWrapper" className="form-group parsley-input">
                                        <label>Mobile Number<span className="tx-danger">*</span></label>
                                        <input id="mobile" type="text" className="form-control"
                                               placeholder="Enter mobile number"
                                               autoComplete="off"
                                               data-parsley-class-handler="#subjectWrapper" required/>
                                    </div>

                                    <div id="passwordWrapper" className="form-group parsley-input">
                                        <label>One-Time Password<span className="tx-danger">*</span></label>
                                        <input id="password" type="text" className="form-control"
                                            placeholder="Enter 4 digits Pin"
                                            autoComplete="off"
                                            maxLength="4"
                                            pattern="[0-9]{4}"
                                            inputMode="numeric"
                                            data-parsley-class-handler="#passwordWrapper"
                                            required
                                        />
                                    </div>

                                    {stateReady ? <button disabled className="btn btn-primary btn-block"><span
                                            className="spinner-border spinner-border-sm mg-r-10" role="status"
                                            aria-hidden="true"/>Please Wait</button> :
                                        <button className="btn btn-primary btn-block">Add User</button>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Dashboard;
